/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface UpdateContractorBody
 */
export interface UpdateContractorBody {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateContractorBody
     */
    id: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof UpdateContractorBody
     */
    userId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractorBody
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractorBody
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractorBody
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateContractorBody
     */
    type: string;
}

/**
 * Check if a given object implements the UpdateContractorBody interface.
 */
export function instanceOfUpdateContractorBody(value: object): value is UpdateContractorBody {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function UpdateContractorBodyFromJSON(json: any): UpdateContractorBody {
    return UpdateContractorBodyFromJSONTyped(json, false);
}

export function UpdateContractorBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateContractorBody {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ActorActivityRecordActorUserIdFromJSON(json['id']),
        'userId': ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'type': json['type'],
    };
}

export function UpdateContractorBodyToJSON(json: any): UpdateContractorBody {
    return UpdateContractorBodyToJSONTyped(json, false);
}

export function UpdateContractorBodyToJSONTyped(value?: UpdateContractorBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ActorActivityRecordActorUserIdToJSON(value['id']),
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'type': value['type'],
    };
}

